import { logEvent } from '@eventbrite/statsig';
import { InteractionsLogger } from './interactionsLogger';
import {
    EventInteraction,
    EventInteractionContext,
    EventInteractions,
} from './types';

export class InteractionsStatsigLogger implements InteractionsLogger {
    ORIGIN = 'web';
    log(interactions: EventInteraction<EventInteractionContext>[]) {
        const promotedEventImpressions = interactions.filter(
            (i) =>
                i.action === EventInteractions.Impression && i.event.isPromoted,
        );

        const statsigEvents = promotedEventImpressions.map((i) => {
            const urgencySignals = i.displayContext?.urgencySignals;
            const hasUrgencySignals = urgencySignals
                ? urgencySignals.length > 0
                : false;

            return {
                name: this.getStatsigEventName(i),
                metadata: {
                    app: this.ORIGIN,
                    rank: `${i.place.position}`,
                    isOnline: `${i.event.isOnline}`,
                    page: `${i.place.page}`,
                    isPromoted: `${i.event.isPromoted}`,
                    hasUrgencySignals: `${hasUrgencySignals}`,
                    isFree: `${i.event.isFree}`,
                },
            };
        });

        statsigEvents.forEach((event) =>
            logEvent(event.name, undefined, event.metadata),
        );
    }

    private getStatsigEventName(i: EventInteraction<EventInteractionContext>) {
        const dataPoints = [
            i.place.name,
            i.place.subInterface?.name,
            i.action,
            'Promoted',
            'Event(s)',
        ].filter((str) => !!str) as string[];
        return dataPoints.map(snakeToTitle).join(' - ');
    }
}

function snakeToTitle(snakeCaseText: string): string {
    const words = snakeCaseText.split('_');
    const capitalizedWords = words.map(
        (word) => word.charAt(0).toUpperCase() + word.slice(1),
    );
    return capitalizedWords.join(' ');
}
